import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import noData from '../../../../assets/errors/noData.png'
//primereact
import { BreadCrumb } from "primereact/breadcrumb";
//components
import CardDocument from "../../../../components/cards/CardDocument";
import { useQuery, useQueryClient } from "react-query";
//services
import { getEnterpriseDrive } from "../../../../services/Enterprise/Documents/getEnterpriseDrive";
import { deleteFile } from "../../../../services/Enterprise/Documents/deleteFile";
import { formatDate } from "../../../../utils/formatDate";
import { Skeleton } from "primereact/skeleton";
import usePermission from "../../../../hooks/usePermission";
import { useAppContext } from "../../../../context/AppContext";
import { toast } from "react-toastify";

const Documents = () => {
  const { id } = useParams(); //get id
  const { state } = useLocation();
  const { permissions } = useAppContext();
  const queryClient = useQueryClient();
  usePermission("22"); // Visualizar Documentos
  
  const itemsBread = [
    {
      template: () => (
        <Link
          to={`/enterprise/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Gestão de Vendas
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterprise/documents/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Documentos
        </Link>
      ),
    },
  ];

  const [currentFolder, setCurrentFolder] = useState(null); // Pasta atual
  const [currentFolderId, setCurrentFolderId] = useState(null); // Pasta atual
  const [items, setItems] = useState([]);

  const { data: documents, isLoading: loadingDocuments } = useQuery({
    queryKey: [`documents${id}`],
    queryFn: () => getEnterpriseDrive(id),
    enabled: !!permissions?.includes("22")
  });

  useEffect(() => {
    const findParentFolder = (folders, parentId) => {
      for (let folder of folders) {
        if (folder.id === parentId) {
          return folder;
        }
        if (folder.children_folder && folder.children_folder.length > 0) {
          const parent = findParentFolder(folder.children_folder, parentId);
          if (parent) {
            return parent;
          }
        }
      }
      return null;
    };

    if (currentFolder) {
      const buildBreadcrumbs = (folder) => {
        let breadcrumbs = [];
        let current = folder;
        while (current) {
          if (current && current.name) {
            const currentId = current.id;
            const currentName = current.name;

            breadcrumbs.unshift({
              template: () => (
                <span
                  className="p-breadcrumb-link"
                  onClick={() => handleFolderClick(currentId)}
                >
                  {currentName}
                </span>
              ),
            });
          }
          current = findParentFolder(documents.folders, current.parent_id);
        }
        return breadcrumbs;
      };

      setItems(buildBreadcrumbs(currentFolder));
    } else {
      setItems([]);
    }
  }, [currentFolder, documents]);

  const handleFolderClick = (folderId) => {
    // console.log("folderId: ", folderId)
    // console.log("currentFolder: ", currentFolder)

    const findFolder = (folders, id) => {
      // console.log("folders: ", folders)

      for (let folder of folders) {
        // console.log("folder: ", folder)
        if (folder.id === id) return folder;
        if (folder.children_folder.length > 0) {
          const found = findFolder(folder.children_folder, id);
          //          // console.log("Found: ", found)
          if (found) return found;
        }
      }
      return null;
    };

    const folder = findFolder(documents.folders, folderId);
    setCurrentFolderId(folderId !== 0 ? folderId : null);
    setCurrentFolder(folder);
  };

  const handleDeleteFile = async (fileId) => {
    const notification = toast.loading("Excluindo arquivo...");
    try {
      await deleteFile(fileId, "drive_enterprise");
      
      queryClient.invalidateQueries([`documents${id}`]);
      
      toast.update(notification, {
        render: "Arquivo excluído com sucesso!",
        autoClose: 3000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao excluir o arquivo. Tente novamente.",
        autoClose: 3000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      console.error("Erro ao excluir arquivo:", error);
    }
  };

  if (loadingDocuments)
    return (
      <div className="row">
        <BreadCrumb
          home={{
            template: () => (
              <Link to={"/salesManagement"} className="p-breadcrumb-link">
                <i className="fa fa-home"></i>
              </Link>
            ),
          }}
          model={itemsBread}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="col-xl-3 col-md-6 col-sm-12 py-4 card-animation"
          >
            <Skeleton width="100%" height="250px"></Skeleton>
          </div>
        ))}
      </div>
    );

  const folders = currentFolder
    ? currentFolder.children_folder
    : documents.folders;
  const files = currentFolder ? currentFolder.files : documents.files;
  const home = {
    template: () => (
      <span className="p-breadcrumb-link" onClick={() => handleFolderClick(0)}>
        <i className="fa fa-home"></i>
      </span>
    ),
  };

  return (
    <>
      <BreadCrumb
        home={{
          template: () => (
            <Link to={"/salesManagement"} className="p-breadcrumb-link">
              <i className="fa fa-home"></i>
            </Link>
          ),
        }}
        model={itemsBread}
        style={{
          background: "transparent",
          border: "none",
          fontSize: "16px",
        }}
      />
      <div className="row">
        <div className="col-md-12 pb-4">
          <div className="row">
            {items && items.length > 0 ? (
              <div className="col-md-9">
                <BreadCrumb
                  home={home}
                  model={items}
                  style={{
                    background: "transparent",
                    border: "none",
                    fontSize: "16px",
                  }}
                />
              </div>
            ) : (
              <div className="col-md-9"></div>
            )}
          </div>
        </div>

        {folders.map((folder) => (
          <CardDocument
            key={folder.id}
            date={">"}
            // fileName={folder.name}
            size={`Arquivos: ${folder.files.length}`}
            description={folder.name}
            onClick={() => handleFolderClick(folder.id)}
            type={"folder"}
          />
        ))}

        {files &&
          files.length > 0 &&
          files.map((file) => (
            <CardDocument
              key={file.id}
              idDoc={file.id}
              date={formatDate(file.created_at)}
              description={`${file.name}.${file.path
                .split(".")
                .pop()
                .toLowerCase()}`}
              size={`Tam: ${(file.size / (1024 * 1024)).toFixed(2)}mb`}
              type={file.path.split(".").pop().toLowerCase()}
              actions
              hasLink
              hasViewFile
              doNotDelete={false}
              deleteFunction={handleDeleteFile}
            />
          ))}

        {files && files.length <= 0 && folders && folders.length <= 0 && (
          <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <img src={noData} alt="error" width="400px" />
            <h4>Não encontramos nenhum documento por aqui</h4>
          </div>
        )}
      </div>
    </>
  );
};

export default Documents;
